import React, { PropTypes } from 'react';

const preserveLineBreaks = content => content.split('\n').join('<br />');

const TextParagraph = ({ paragraph }) => (
  <div
    className="inner"
    dangerouslySetInnerHTML={{ __html: preserveLineBreaks(paragraph.content) }}
  />
);

TextParagraph.propTypes = {
  paragraph: PropTypes.object.isRequired,
};

export default TextParagraph;



// WEBPACK FOOTER //
// ./src/modules/memo/components/TextParagraph.js